export default __webpack_public_path__ + "static/media/interstellar.314c432e.jpg";